export const HEDGING_SECTIONS = [
  { key: 'derivatives', label: 'Derivatives at fair value (ASC 815)' },
  { key: 'inventory', label: 'Inventory fair value (fair-value option, ASC 825)' },
  { key: 'realized', label: 'Realized hedge results' },
] as const

export type HedgingSectionKey = typeof HEDGING_SECTIONS[number]['key']

export interface IFairValueInstrument {
  id: number
  section: HedgingSectionKey | string
  instrument: string
  reference: string
  notional: number | null
  fvGlAccountNo: string
  fairValue: number
  glBalance: number
  variance: number
}

export interface IHedgingSection {
  key: string
  label: string
  rows: IFairValueInstrument[]
  subtotal: { fairValue: number; glBalance: number; variance: number } | null
}

export const emptyFairValueInstrument = (): Partial<IFairValueInstrument> => ({
  section: '',
  instrument: '',
  reference: '',
  notional: null,
  fvGlAccountNo: '',
  fairValue: 0,
})
